import { useEffect, useState } from 'react';
import useVendorStore from '../../AuthStore/store/authStore.js'
import { FaEnvelope, FaPhoneAlt, FaChartLine, FaMoneyBillWave, FaCog, FaUser, FaFileAlt, FaWallet } from 'react-icons/fa';
import { MdDashboard, MdSettings } from 'react-icons/md';
import { Link } from 'react-router-dom';
import  SubmittedForms from './SubmittedFromsVendor.js';
import { getPolicyFromData } from '../../Services/vendorFromServices.js';

const BrokerDashboard = () => {
  const { setVendor,authToken,getvendorId} = useVendorStore();
  const [activeTab, setActiveTab] = useState('overview');
  const [withdrawAmount, setWithdrawAmount] = useState('');
  // const [SubmittedFrom, setSubmittedFrom] = useState([]);
  const [filteredPending, setfilteredPending] = useState(0);
  const [filteredApproved, setfilteredApproved] = useState(0);

 
  

  useEffect(()=>{
   const fetchFromData=async()=>{
     if (!authToken) {
      return<>Token not Found !</>
     }
     try {

      const res= await getPolicyFromData(authToken,getvendorId);

      // const count=Object.keys(res.data).length;
      // const count=(res.data).length;
      // console.log("res policy count: ",count);

      const filteredPending = res.data.filter(item => item.status === "pending");
      setfilteredPending(filteredPending.length);
      const filteredApproved = res.data.filter(item => item.status === "approved");
      setfilteredApproved(filteredApproved.length);


      // setSubmittedFrom(res.data||[]);
      
      
     } catch (error) {
      
      console.log("error in fetching data in broker dashbord: ",error);
      

     }

   }
   fetchFromData();
  },[authToken,getvendorId])


  //  console.log(SubmittedFrom);

  // Sample data - would typically come from API
  const brokerData = {
    name: `${setVendor?.f_name || ""} ${setVendor?.l_name || ""}`,
    company: "Karikar Eduwealth Pvt. Ltd.",
    brokerId: `${getvendorId || "N/A"}`,
    status: setVendor?.is_vendor === "1" ? "active" : "inactive",
    email: setVendor?.email || "",
    phone: setVendor?.phone || "",
    UserType: 'Broker',
    photo: "https://ui-avatars.com/api/?background=random&name=" + 
            encodeURIComponent(`${setVendor?.f_name || ""} ${setVendor?.l_name || ""}`),
    performance: {
      policiesSold: filteredApproved,
      policiesInProcess: filteredPending,
      conversionRate: "78%",
      clientSatisfaction: "94%"
    },
    earnings: {
      daily: "$425",
      monthly: "$8,250",
      ytd: "$42,500",
      currentMonth: "$8,250",
      lifetime: "$127,800",
      pending: "$1,250"
    },
    payouts: [
      {
        id: 1,
        date: "2023-10-15",
        amount: "$4,200",
        method: "Bank Transfer",
        status: "Completed"
      },
      {
        id: 2,
        date: "2023-09-15",
        amount: "$3,800",
        method: "Bank Transfer",
        status: "Completed"
      },
      {
        id: 3,
        date: "2023-08-15",
        amount: "$4,500",
        method: "Bank Transfer",
        status: "Completed"
      }
    ]
  };

  const handleWithdraw = (e) => {
    e.preventDefault();
    alert(`Withdrawal request for $${withdrawAmount} submitted!`);
    setWithdrawAmount('');
  };

  const statusColor = brokerData.status === 'active' 
    ? 'bg-emerald-100 text-emerald-800 border-emerald-200' 
    : brokerData.status === 'pending' 
      ? 'bg-amber-100 text-amber-800 border-amber-200' 
      : 'bg-red-100 text-red-800 border-red-200';

  const tabs = [
    { id: 'overview', label: 'Overview', icon: MdDashboard },
    { id: 'forms', label: 'Forms', icon: FaFileAlt },
    { id: 'earnings', label: 'Earnings', icon: FaMoneyBillWave },
    { id: 'settings', label: 'Settings', icon: MdSettings }
  ];

  const StatCard = ({ title, value, icon: Icon, color = 'blue', trend }) => {
    const colorClasses = {
      blue: 'bg-blue-50 text-blue-600',
      emerald: 'bg-emerald-50 text-emerald-600',
      purple: 'bg-purple-50 text-purple-600',
      amber: 'bg-amber-50 text-amber-600'
    };

    return (
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 sm:p-6 hover:shadow-md transition-shadow duration-200">
        <div className="flex items-center justify-between">
          <div className="flex-1 min-w-0">
            <p className="text-xs sm:text-sm font-medium text-gray-600 truncate">{title}</p>
            <p className="text-xl sm:text-2xl font-bold text-gray-900 mt-1 truncate">{value}</p>
            {trend && (
              <span className={`inline-flex items-center text-xs font-medium mt-1 ${
                trend.value > 0 ? 'text-emerald-600' : 'text-red-600'
              }`}>
                {trend.value > 0 ? '↑' : '↓'} {Math.abs(trend.value)}% {trend.label}
              </span>
            )}
          </div>
          <div className={`p-2 sm:p-3 rounded-full ml-3 ${colorClasses[color]}`}>
            <Icon className="h-4 w-4 sm:h-6 sm:w-6" />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <main className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-4 sm:py-8">
        {/* Header */}
        <div className="mb-4 sm:mb-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Broker Dashboard</h1>
              <p className="text-gray-600 mt-1 sm:mt-2 text-sm sm:text-base">Welcome back, {brokerData.name}!</p>
            </div>
          </div>
        </div>

        {/* Horizontal Scrollable Tabs */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-1 mb-6 sm:mb-8">
          <div className="overflow-x-auto scrollbar-hide">
            <nav className="flex space-x-1 min-w-max">
              {tabs.map((tab) => {
                const Icon = tab.icon;
                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`flex items-center px-4 py-3 rounded-lg font-medium text-sm transition-all duration-200 whitespace-nowrap ${
                      activeTab === tab.id
                        ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-md'
                        : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                    }`}
                  >
                    <Icon className="h-4 w-4 mr-2" />
                    {tab.label}
                  </button>
                );
              })}
            </nav>
          </div>
        </div>

        {/* Profile Overview */}
        {activeTab === 'overview' && (
          <div className="space-y-4 sm:space-y-6">
            {/* Profile Header */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
              <div className="bg-gradient-to-r from-blue-500 to-blue-600 h-16 sm:h-20"></div>
              <div className="px-4 sm:px-6 pb-4 sm:pb-6 -mt-8 sm:-mt-10">
                <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between space-y-4 sm:space-y-0">
                  <div className="flex flex-col sm:flex-row sm:items-end space-y-3 sm:space-y-0 sm:space-x-4">
                    <img 
                      className="h-16 w-16 sm:h-20 sm:w-20 rounded-full border-4 border-white shadow-lg self-center sm:self-auto" 
                      src={brokerData.photo} 
                      alt="Profile" 
                    />
                    <div className="text-center sm:text-left pb-0 sm:pb-2">
                      <h2 className="text-xl sm:text-2xl font-bold text-gray-900">{brokerData.name}</h2>
                      <p className="text-gray-600 text-sm sm:text-base">{brokerData.company}</p>
                    </div>
                  </div>
                  <div className="text-center sm:text-right">
                    <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs sm:text-sm font-medium border ${statusColor}`}>
                      {brokerData.status.charAt(0).toUpperCase() + brokerData.status.slice(1)}
                    </span>
                    <p className="text-xs sm:text-sm font-semibold text-gray-600 mt-1"> Broker ID: {brokerData.brokerId}</p>
                  </div>
                </div>
                
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-6 mt-4 sm:mt-6">
                  <div className="flex items-center p-3 sm:p-4 bg-gray-50 rounded-lg">
                    <FaEnvelope className="h-4 w-4 sm:h-5 sm:w-5 text-blue-600 mr-2 sm:mr-3" />
                    <div className="min-w-0">
                      <p className="text-xs sm:text-sm text-gray-600 truncate">Email</p>
                      <p className="font-medium text-sm sm:text-base truncate">{brokerData.email}</p>
                    </div>
                  </div>
                  <div className="flex items-center p-3 sm:p-4 bg-gray-50 rounded-lg">
                    <FaPhoneAlt className="h-4 w-4 sm:h-5 sm:w-5 text-blue-600 mr-2 sm:mr-3" />
                    <div className="min-w-0">
                      <p className="text-xs sm:text-sm text-gray-600 truncate">Phone</p>
                      <p className="font-medium text-sm sm:text-base truncate">{brokerData.phone}</p>
                    </div>
                  </div>
                  <div className="flex items-center p-3 sm:p-4 bg-gray-50 rounded-lg">
                    <FaUser className="h-4 w-4 sm:h-5 sm:w-5 text-blue-600 mr-2 sm:mr-3" />
                    <div className="min-w-0">
                      <p className="text-xs sm:text-sm text-gray-600 truncate">Role :{brokerData.UserType}</p>
                      <p className="font-medium text-sm sm:text-base truncate">ID:{setVendor?.id}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Performance Metrics */}
            <div className="grid grid-cols-2 gap-3 sm:gap-4 md:gap-6">
              <StatCard 
                title="Policies Sold" 
                value={brokerData.performance.policiesSold} 
                icon={FaChartLine}
                color="emerald"
                trend={{ value: 12, label: "this month" }}
              />
              <StatCard 
                title="In Process" 
                value={brokerData.performance.policiesInProcess} 
                icon={FaFileAlt}
                color="blue"
              />
              <StatCard 
                title="Conversion Rate" 
                value={brokerData.performance.conversionRate} 
                icon={FaChartLine}
                color="purple"
                trend={{ value: 5, label: "this month" }}
              />
              <StatCard 
                title="Satisfaction" 
                value={brokerData.performance.clientSatisfaction} 
                icon={FaUser}
                color="amber"
              />
            </div>

            {/* Earnings Overview */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6">
              <div className="lg:col-span-2 bg-white rounded-xl shadow-sm border border-gray-100 p-4 sm:p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-3 sm:mb-4">Earnings Overview</h3>
                <div className="grid grid-cols-3 gap-2 sm:gap-4">
                  <div className="text-center p-3 sm:p-4 bg-blue-50 rounded-lg">
                    <p className="text-xs sm:text-sm text-blue-600 font-medium">Daily</p>
                    <p className="text-lg sm:text-xl font-bold text-gray-900 mt-1">{brokerData.earnings.daily}</p>
                  </div>
                  <div className="text-center p-3 sm:p-4 bg-emerald-50 rounded-lg">
                    <p className="text-xs sm:text-sm text-emerald-600 font-medium">Monthly</p>
                    <p className="text-lg sm:text-xl font-bold text-gray-900 mt-1">{brokerData.earnings.monthly}</p>
                  </div>
                  <div className="text-center p-3 sm:p-4 bg-purple-50 rounded-lg">
                    <p className="text-xs sm:text-sm text-purple-600 font-medium">YTD</p>
                    <p className="text-lg sm:text-xl font-bold text-gray-900 mt-1">{brokerData.earnings.ytd}</p>
                  </div>
                </div>
              </div>
              
              <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 sm:p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-3 sm:mb-4">Quick Actions</h3>
                <div className="space-y-2 sm:space-y-3">
                  <button className="w-full flex items-center justify-center px-3 sm:px-4 py-2 sm:py-3 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg font-medium hover:from-blue-600 hover:to-blue-700 transition-all duration-200 text-sm sm:text-base">
                    <FaFileAlt className="h-3 w-3 sm:h-4 sm:w-4 mr-2" />
                    New Form
                  </button>
                  <button className="w-full flex items-center justify-center px-3 sm:px-4 py-2 sm:py-3 bg-gray-100 text-gray-700 rounded-lg font-medium hover:bg-gray-200 transition-all duration-200 text-sm sm:text-base">
                    <FaWallet className="h-3 w-3 sm:h-4 sm:w-4 mr-2" />
                    Commission Report
                  </button>
                  <button className="w-full flex items-center justify-center px-3 sm:px-4 py-2 sm:py-3 bg-gray-100 text-gray-700 rounded-lg font-medium hover:bg-gray-200 transition-all duration-200 text-sm sm:text-base">
                    <FaCog className="h-3 w-3 sm:h-4 sm:w-4 mr-2" />
                    Settings
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Forms Tab */}
        {activeTab === 'forms' && (
          <div className="space-y-4 sm:space-y-6">
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 sm:p-6">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4 sm:mb-6">
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900">Submitted Forms</h2>
                <Link to='/policy-buy'>
                  <button className="flex items-center justify-center px-3 sm:px-4 py-2 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg font-medium hover:from-blue-600 hover:to-blue-700 transition-all duration-200 text-sm sm:text-base">
                  <FaFileAlt className="h-3 w-3 sm:h-4 sm:w-4 mr-2" />
                  New Form
                </button></Link>
              </div>
              <div className="bg-gray-50 rounded-lg p-4 text-center">
                {/* <p className="text-gray-600">Forms component would go here</p> */}
                <SubmittedForms />
              </div>
            </div>
          </div>
        )}

        {/* Earnings & Payouts */}
        {activeTab === 'earnings' && (
          <div className="space-y-4 sm:space-y-6">
            {/* Earnings Summary */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6">
              <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 sm:p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-3 sm:mb-4">Current Balance</h3>
                <div className="text-center">
                  <p className="text-2xl sm:text-4xl font-bold text-gray-900 mb-1 sm:mb-2">{brokerData.earnings.currentMonth}</p>
                  <p className="text-xs sm:text-sm text-gray-600">Available for withdrawal</p>
                </div>
                <div className="mt-4 sm:mt-6 p-3 sm:p-4 bg-amber-50 rounded-lg">
                  <div className="flex items-center justify-between">
                    <span className="text-xs sm:text-sm font-medium text-amber-700">Pending</span>
                    <span className="text-base sm:text-lg font-bold text-amber-900">{brokerData.earnings.pending}</span>
                  </div>
                </div>
              </div>

              <div className="lg:col-span-2 bg-white rounded-xl shadow-sm border border-gray-100 p-4 sm:p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-3 sm:mb-4">Withdraw Funds</h3>
                <form onSubmit={handleWithdraw} className="space-y-3 sm:space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1 sm:mb-2">Amount</label>
                    <div className="relative">
                      <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">$</span>
                      <input
                        type="number"
                        value={withdrawAmount}
                        onChange={(e) => setWithdrawAmount(e.target.value)}
                        className="pl-8 w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm sm:text-base"
                        placeholder="0.00"
                      />
                    </div>
                  </div>
                  <button
                    type="submit"
                    className="w-full bg-gradient-to-r from-blue-500 to-blue-600 text-white py-2 sm:py-3 px-4 rounded-lg font-medium hover:from-blue-600 hover:to-blue-700 transition-all duration-200 text-sm sm:text-base"
                  >
                    Request Withdrawal
                  </button>
                </form>
              </div>
            </div>

            {/* Payout History */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
              <div className="px-4 sm:px-6 py-3 sm:py-4 border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-900">Payout History</h3>
              </div>
              <div className="overflow-x-auto">
                <table className="w-full min-w-[500px]">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 sm:px-6 py-2 sm:py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
                      <th className="px-4 sm:px-6 py-2 sm:py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
                      <th className="px-4 sm:px-6 py-2 sm:py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Method</th>
                      <th className="px-4 sm:px-6 py-2 sm:py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {brokerData.payouts.map((payout) => (
                      <tr key={payout.id} className="hover:bg-gray-50">
                        <td className="px-4 sm:px-6 py-3 sm:py-4 whitespace-nowrap text-sm text-gray-900">{payout.date}</td>
                        <td className="px-4 sm:px-6 py-3 sm:py-4 whitespace-nowrap text-sm font-semibold text-gray-900">{payout.amount}</td>
                        <td className="px-4 sm:px-6 py-3 sm:py-4 whitespace-nowrap text-sm text-gray-600">{payout.method}</td>
                        <td className="px-4 sm:px-6 py-3 sm:py-4 whitespace-nowrap">
                          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-emerald-100 text-emerald-800">
                            {payout.status}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {/* Settings */}
        {activeTab === 'settings' && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
            {/* Account Settings */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 sm:p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-3 sm:mb-4">Change Password</h3>
              <div className="space-y-4 sm:space-y-6">
                <form className="space-y-3 sm:space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Current Password</label>
                    <input type="password" className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm sm:text-base" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">New Password</label>
                    <input type="password" className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm sm:text-base" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Confirm Password</label>
                    <input type="password" className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm sm:text-base" />
                  </div>
                  <button className="w-full bg-gradient-to-r from-blue-500 to-blue-600 text-white py-2 px-4 rounded-lg font-medium hover:from-blue-600 hover:to-blue-700 transition-all duration-200 text-sm sm:text-base">
                    Update Password
                  </button>
                </form>
              </div>
            </div>
            
          </div>
        )}
      </main>

      {/* Custom CSS for hiding scrollbar but keeping functionality */}
      <style jsx>{`
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
};

export default BrokerDashboard;